import React, { useEffect, Suspense } from 'react'
import { Route, Link } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import qs from 'qs'
import { Button, Modal, message } from 'antd'
// import Home from './pages/home/Home.jsx';
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { isLowLevelBrowser } from './util'
import { sentryIngnoreData } from './util/sentryIgnore'
import { changeLogin, changeModalVisible, setDomain, initGoodCompare } from './redux/actions'
import { getToken, axiosChangeSite } from './api'
import { getUrlParams } from './tools/tools'
import { gio } from './util/gio'
import './App.css'

gio.init()

const Home = React.lazy(() => import('./pages/home/Home'))
const DevelopSwitchEnv = React.lazy(() => import('./component/developSwitchEnv'))

const userId = localStorage?.getItem('userId'),
  userName = localStorage?.getItem('userName'),
  telephone = localStorage?.getItem('telephone')

Sentry.init({
  dsn: 'https://87b60631a47f41d18594fec4aa363f18@appsentry.freshfood.cn/82',
  environment: window.RUN_CONFIG.env === 'prod' ? 'production' : 'test',
  ignoreErrors: [...sentryIngnoreData],
  release: 'fe-web-bbc',
  integrations: [
    new Sentry.Integrations.GlobalHandlers({
      onerror: true,
      onunhandledrejection: false,
    }),
    new Sentry.Integrations.Breadcrumbs({
      console: false,
      error: false,
    }),
  ],
})
Sentry.configureScope(scope => {
  scope.setUser({
    id: userId,
    uid: userId,
    userName,
    telephone,
  })
})

function App(props) {
  useEffect(() => {
    const domain = window.location.origin
    props.setDomain(domain)
    props.initGoodCompare()

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        console.log('窗口不可见')
      } else {
        console.log('窗口可见')
        // window.location.reload()
      }
    })

    getIsLogin()

    if (isLowLevelBrowser()) {
      Modal.warning({
        title: '当前浏览器版本过低，请升级浏览器版本，否则会影响商城使用',
      })
    }

    return () => {}
  }, [])

  //登录流程
  const getIsLogin = async () => {
    //获取浏览器 code 和 state 站点信息
    const { code, state } = getUrlParams()
    const loginToken = localStorage.getItem('loginToken')

    //state是否变化判断与缓存state对比
    const stateIsChanged = state && state !== localStorage.getItem('state')

    if (state) {
      localStorage.setItem('code', code)
      localStorage.setItem('state', state)
      localStorage.setItem('siteId', state)
      //保存原始链接，方便看code,state
      localStorage.setItem('originUrl', window.location.href)
    }

    //loginToken不存在，通过认证接口绑定siteId
    if (!loginToken) {
      await getLogin()
      return
    }

    //loginToken存在，已登录
    props.changeLogin(true)

    //新链接
    if (stateIsChanged) {
      reqChangeSite()
      return
    }

    justToHome()
  }

  //认证接口，传站点信息，返回对应站点的数据
  const getLogin = async () => {
    const { code, state } = getUrlParams()

    //退出登录取缓存里的
    let sessionCode = localStorage.getItem('code')
    let sessionSate = localStorage.getItem('state')

    const obj = {
      params: { code: code || sessionCode, state: state || sessionSate },
    }

    return getToken(obj)
      ?.then(res => {
        console.log('res: ', res)
      })
      ?.catch(error => {
        if (Number(error?.data?.code) === -201) {
          //认证token只是为了非登录状态下展示首页
          localStorage.setItem('non-login-token', error?.data?.data?.loginToken)
          localStorage.setItem('userId', error?.data?.data?.userId)
          justToHome()
        }
      })
  }

  //切换站点
  const reqChangeSite = async item => {
    //保存站点信息
    const { state } = getUrlParams()
    const res = await axiosChangeSite({
      data: {
        siteId: state,
      },
    })
    if (Number(res?.code) === 200) {
      justToHome(true)
    } else {
      message.error(res?.message)
    }
  }

  // 同意
  const handleOk = () => {
    const { href: search } = window.location
    props.history.push({
      pathname: '/login',
      search: qs.stringify({ callback: search }), // search: 'id=1&name=chris',
    })
    props.changeModalVisible(false)
    return (
      <Link
        to={{
          pathname: `/detail`,
          search: qs.stringify({ gid: '12' }),
        }}
      ></Link>
    )
  }
  // 不同意
  const handleCancel = () => {
    props.changeModalVisible(false)
    sessionStorage.removeItem('preLoginUrl')
  }

  //去掉url中的code,state参数，保持当前路径
  const justToHome = reload => {
    // 获取当前路径
    const currentPath = window.location.hash.substring(1) || '/home'
    // 只有当当前路径是根路径时才重定向到首页
    if (currentPath === '/' || currentPath === '') {
      window.location.href = window.location.origin + '#/home'
    } else {
      if (reload) {
        window.location.reload()
      }
    }
  }

  return (
    <div className='home-wrap'>
      <Suspense fallback={<div className='home-placeholder'></div>}>
        <Route path={'/'} component={Home}></Route>
      </Suspense>
      {/* 服务协议是否同意 */}
      <Modal open={props.isModalStatus} onOk={handleOk} onCancel={handleCancel} footer={null}>
        <div className='agreement-container'>
          <p className='title'>声明与政策</p>
          <div className='content'>
            <p>欢迎您来到彩食鲜企业购！</p>
            <p>
              我们依据最新法律法规要求，制定并更新了
              <a href='http://yhcsx.yonghui.cn/simages/wxmall/regist_protocol.html' rel='noopener noreferrer'>
                《注册协议》
              </a>
              <span className='color-gold'>、</span>
              <a href='https://yhcsx.yonghui.cn/simages/wxmall/service_protocol.html' rel='noopener noreferrer'>
                《售后政策》
              </a>
              以及
              <a href='https://yhcsx.yonghui.cn/simages/wxmall/PrivacyAgreement.html' rel='noopener noreferrer'>
                《隐私协议》
              </a>
              。
            </p>
            <p>您需阅读并同意相关政策条款方可进行登录。</p>
          </div>
          <div className='buttonlist'>
            <Button type='primary' onClick={handleOk}>
              同意并继续
            </Button>
            <Button cla onClick={handleCancel}>
              不同意
            </Button>
          </div>
        </div>
      </Modal>
      {/* <AddressModal /> */}

      {/* 开发人员，不同环境切换 */}
      {window?.location?.hostname === 'localhost' && (
        <Suspense fallback={<div className='home-placeholder'></div>}>
          <DevelopSwitchEnv />
        </Suspense>
      )}
    </div>
  )
}

export default withRouter(connect(state => ({ domain: state.doMain, isModalStatus: state.isModalStatus }), { setDomain, changeLogin, changeModalVisible, initGoodCompare })(App))
